import { create } from 'zustand';

export type ThemeMode = 'light' | 'dark' | 'auto';

function getInitialTheme(): ThemeMode {
  const stored = localStorage.getItem('app-theme');
  if (stored === 'light' || stored === 'dark' || stored === 'auto') return stored;
  return 'light';
}

function resolveTheme(mode: ThemeMode): 'light' | 'dark' {
  if (mode === 'auto') {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }
  return mode;
}

interface AppState {
  sidebarCollapsed: boolean;
  themeMode: ThemeMode;
  resolvedTheme: 'light' | 'dark';
  toggleSidebar: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
  setThemeMode: (mode: ThemeMode) => void;
}

export const useAppStore = create<AppState>((set) => ({
  sidebarCollapsed: false,
  themeMode: getInitialTheme(),
  resolvedTheme: resolveTheme(getInitialTheme()),
  toggleSidebar: () => set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
  setSidebarCollapsed: (collapsed) => set({ sidebarCollapsed: collapsed }),
  setThemeMode: (mode) => {
    localStorage.setItem('app-theme', mode);
    set({ themeMode: mode, resolvedTheme: resolveTheme(mode) });
  },
}));